import { render, staticRenderFns } from "./taskShopList.vue?vue&type=template&id=1b9ea8a0&scoped=true&"
import script from "./taskShopList.vue?vue&type=script&lang=js&"
export * from "./taskShopList.vue?vue&type=script&lang=js&"
import style0 from "./taskShopList.vue?vue&type=style&index=0&id=1b9ea8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9ea8a0",
  null
  
)

export default component.exports